<template>
  <v-form
    ref="formCreateRepairCenter"
    v-model="formStepTransporterValid"
    @submit.prevent="submit"
  >
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-xl mt-4 d-flex-column parent-card" :border="false" :elevation="0">
          <v-row>
            <v-col class="pb-0">
              <h1>{{ $t('FILE_STEP_TRANSPORT_MODALITY.TITLE') }}</h1>
            </v-col>
          </v-row>
          <!--ADDRESS INFORMATION-->
          <h1 @click.stop.prevent="stepper = 1"
              class="information-content-title mb-2 d-flex justify-space-between"
              :class="stepper === 2 ? 'title-button' : null">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.SUB_TITLE.ADDRESS_INFORMATION') }}
            <img v-if="showStepTwo"
                 alt="dialog-icon"
                 class="svg-check-rounded"
                 src="@/assets/icons/file/check_round.svg" />
          </h1>
          <v-divider :thickness="2" />

          <div v-if="stepper === 1">
            <!--MODALITY SELECT-->
            <v-col cols="12" md="5" class="pl-0 mt-5">
              <p class="mb-4">{{ $t('FILE_STEP_TRANSPORT_MODALITY.SELECT.MODALITY_TYPE.TITLE') }}</p>
              <v-autocomplete
                id="select-transport-modality"
                v-model="selectedTransportModality"
                :items="transportModalityList"
                :no-data-text="$t('COMMON.NO_DATA')"
                :placeholder="$t('FILE_STEP_TRANSPORT_MODALITY.PLACEHOLDER.MODALITY_TYPE')"
                clearable
                hide-details
                item-title="name"
                item-value="value"
                :rules="requiredRules"
                return-object
              >
                <template v-slot:selection="{ item }">
                  <v-chip size="small">
                    <span>{{ item.title }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item, props }">
                  <v-list-item
                    :title="item.title"
                    :value="item.value"
                    v-bind="props"
                  >
                    <v-tooltip
                      v-if="shouldShowTooltip(item, 'select-transport-modality')"
                      activator="parent"
                      location="bottom left"
                    >
                      {{ item.title }}
                    </v-tooltip>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!--IMMEDIATE TRANSPORT SELECTED: ADDRESS COMPLEMENT DEPARTURE, DELIVERY, RETURN-->
            <div v-if="repairCenter">
              <p class="mt-5">{{ $t('FILE_STEP_TRANSPORT_MODALITY.SELECT.ADDRESS.TITLE') }}</p>
              <v-row class=" mt-5">
                <!--DEPARTURE-->
                <v-col cols="12" md="4">
                  <v-card class="address-card">
                    <!--TITLE-->
                    <v-row class="mb-2">
                      <v-col class="d-flex justify-space-between align-center pb-0">
                        <p class="title-card">{{
                            $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.TITLE.SEND_FROM')
                          }}</p>
                        <button @click.stop.prevent="openAddressModal('send_from')">
                          <img src="@/assets/icons/file/pen.svg" alt="pen svg" class="empty-image">
                        </button>
                      </v-col>
                    </v-row>
                    <!--ADDRESS NAME-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.NAME') }}</p>
                        <p class="content-value">{{ departureAddress.name }}</p>
                      </v-col>
                    </v-row>
                    <!--ADDRESS-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.ADDRESS') }}</p>
                        <p class="content-value">{{ departureAddress.number + ' ' + departureAddress.street }}</p>
                      </v-col>
                    </v-row>
                    <!--COMPLEMENT_ONE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{
                            $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.COMPLEMENT_ONE')
                          }}</p>
                        <p class="content-value">{{ departureAddress.complementOne }}</p>
                      </v-col>
                    </v-row>
                    <!--COMPLEMENT_TWO-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{
                            $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.COMPLEMENT_TWO')
                          }}</p>
                        <p class="content-value">{{ departureAddress.complementTwo }}</p>
                      </v-col>
                    </v-row>
                    <!--ZIP_CODE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.ZIP_CODE') }}</p>
                        <p class="content-value">{{ departureAddress.zipCode + ' ' + departureAddress.city }}</p>
                      </v-col>
                    </v-row>

                    <!--CONTACT_NAME-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.CONTACT_NAME') }}</p>
                        <p class="content-value">{{ departureAddress.contactName }}</p>
                      </v-col>
                    </v-row>

                    <!--CONTACT_EMAIL-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.CONTACT_EMAIL') }}</p>
                        <p class="content-value">{{ departureAddress.contactEmail }}</p>
                      </v-col>
                    </v-row>

                    <!--CONTACT_PHONE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-2">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.CONTACT_PHONE') }}</p>
                        <p class="content-value">{{ departureAddress.contactPhone }}</p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <!--DELIVERY-->
                <v-col cols="12" md="4">
                  <v-card class="address-card transporter-card">
                    <!--TITLE-->
                    <v-row class="mb-2">
                      <v-col class="d-flex justify-space-between align-center pb-0">
                        <p class="title-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.TITLE.SEND_TO') }}</p>
                      </v-col>
                    </v-row>
                    <!--ADDRESS NAME-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.NAME') }}</p>
                        <p class="content-value">{{ sendTo.name }}</p>
                      </v-col>
                    </v-row>
                    <!--ADDRESS-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.ADDRESS') }}</p>
                        <p class="content-value">{{ sendTo.number + ' ' + sendTo.street }}</p>
                      </v-col>
                    </v-row>
                    <!--COMPLEMENT_ONE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{
                            $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.COMPLEMENT_ONE')
                          }}</p>
                        <p class="content-value">{{ sendTo.complementOne }}</p>
                      </v-col>
                    </v-row>

                    <!--COMPLEMENT_ONE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">-</p>
                        <p class="content-value">-</p>
                      </v-col>
                    </v-row>
                    <!--ZIP_CODE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.ZIP_CODE') }}</p>
                        <p class="content-value">{{ sendTo.zipCode + ' ' + sendTo.city }}</p>
                      </v-col>
                    </v-row>

                    <!--CONTACT_NAME-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.CONTACT_NAME') }}</p>
                        <p class="content-value">{{ sendTo.contactName }}</p>
                      </v-col>
                    </v-row>

                    <!--CONTACT_EMAIL-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.CONTACT_EMAIL') }}</p>
                        <p class="content-value">{{ sendTo.contactEmail }}</p>
                      </v-col>
                    </v-row>

                    <!--CONTACT_PHONE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-2">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.CONTACT_PHONE') }}</p>
                        <p class="content-value">{{ sendTo.contactPhone }}</p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <!--RETURN-->
                <v-col cols="12" md="4">
                  <v-card class="address-card">
                    <!--TITLE-->
                    <v-row class="mb-2">
                      <v-col class="d-flex justify-space-between align-center pb-0">
                        <p class="title-card">{{
                            $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.TITLE.RECEIVE_TO')
                          }}</p>
                        <button
                          v-if="isWhiteListFlow"
                          @click.stop.prevent="openAddressModal('receive_by')">
                          <img src="@/assets/icons/file/pen.svg" alt="pen svg" class="empty-image">
                        </button>
                      </v-col>
                    </v-row>
                    <!--ADDRESS NAME-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.NAME') }}</p>
                        <p class="content-value">{{ returnAddress.name }}</p>
                      </v-col>
                    </v-row>
                    <!--ADDRESS-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.ADDRESS') }}</p>
                        <p class="content-value">{{ returnAddress.number + ' ' + returnAddress.street }}</p>
                      </v-col>
                    </v-row>
                    <!--COMPLEMENT_ONE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{
                            $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.COMPLEMENT_ONE')
                          }}</p>
                        <p class="content-value">{{ returnAddress.complementOne }}</p>
                      </v-col>
                    </v-row>
                    <!--COMPLEMENT_TWO-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{
                            $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.COMPLEMENT_TWO')
                          }}</p>
                        <p class="content-value">{{ returnAddress.complementTwo }}</p>
                      </v-col>
                    </v-row>
                    <!--ZIP_CODE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.ZIP_CODE') }}</p>
                        <p class="content-value">{{ returnAddress.zipCode + ' ' + returnAddress.city }}</p>
                      </v-col>
                    </v-row>

                    <!--CONTACT_NAME-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.CONTACT_NAME') }}</p>
                        <p class="content-value">{{ returnAddress.contactName }}</p>
                      </v-col>
                    </v-row>

                    <!--CONTACT_EMAIL-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pb-0">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.CONTACT_EMAIL') }}</p>
                        <p class="content-value">{{ returnAddress.contactEmail }}</p>
                      </v-col>
                    </v-row>

                    <!--CONTACT_PHONE-->
                    <v-row>
                      <v-col class="d-flex justify-space-between align-center pt-2 pb-2">
                        <p class="content-card">{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_ONE.CONTACT_PHONE') }}</p>
                        <p class="content-value">{{ returnAddress.contactPhone }}</p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              <!--MODALITY VALIDATION IF IMMEDIATE TRANSPORT SELECTED-->
              <v-btn
                v-if="!showStepTwo"
                :disabled="transporter === null"
                class=" mt-10 pa-5  boom-button"
                variant="outlined"
                @click="nextStep()"
              >
                {{ $t('FILE_STEP_TRANSPORT_MODALITY.BUTTON.NEXT') }}
              </v-btn>
            </div>
          </div>

          <!--IMMEDIATE TRANSPORT SELECTED STEP 2-->
          <div v-if="productList && showStepTwo">
            <h1 @click.stop.prevent="stepper = 2"
                class="information-content-title mb-2"
                :class="stepper === 1 ? 'title-button' : null"
            >
              {{ $t('FILE_STEP_TRANSPORT_MODALITY.SUB_TITLE.TRANSPORTER_INFORMATION') }}
            </h1>
            <v-divider :thickness="2"></v-divider>
          </div>
          <div v-if="stepper === 2 && productList">
            <div v-if="stepper === 2" class="mt-10">
              <v-row class="mt-10">
                <v-col md="4" class="align-content-space-between">
                  <p data-custom="true" class="pb-5 title-product">
                    {{ $t('FILE_STEP_TRANSPORT_MODALITY.SELECT_MATERIAL.TITLE') }}
                  </p>
                  <v-row
                    v-for="product in productList"
                    :key="product.technical_id"
                    class="content-product d-flex justify-space-between"
                  >
                    <v-col class="pb-1 d-flex justify-space-between align-center">
                      <p
                        :class="{ 'font-weight-bold': product.product_type === ProductTypeConstant.PALLET }"
                      >
                        {{ $t('COMMON.PRODUCT_TYPE.' + product.product_type) }}
                      </p>
                      <div class="d-flex align-center ga-2">
                        <button :disabled="product.quantity <= 0"
                                @click.stop.prevent="product.quantity-- ; makeAllCalculate()"
                                class="btn-minus d-flex align-center justify-center"
                        >
                          <img :class="product.quantity <= 0 ? 'svg-minus-disabled': null"
                               alt="dialog-icon"
                               src="@/assets/icons/file/minus.svg"
                          />
                        </button>
                        <p>
                          {{ product.quantity }}
                        </p>
                        <button :disabled="product.quantity >= 1"
                                @click.stop.prevent="
                          product.quantity++ ;
                          makeAllCalculate();
                          product.product_type === 'BATTERY'? openBatteryModal(product) : null "
                                class="btn-plus d-flex align-center justify-center"
                        >
                          <img :class="product.quantity >= 1 ? 'svg-minus-disabled': ''"
                               alt="dialog-icon"
                               src="@/assets/icons/file/plus.svg"
                          />
                        </button>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col md="4" class="align-content-space-between">
                  <v-card v-if="wattHour && wattHour >= 100 && !expressCheckbox" class="watt-hour-card">
                    <div class="d-flex flex-row">
                      <div class="d-flex justify-center align-center pa-3">
                        <img
                          alt="info-svg"
                          class="svg-check-rounded"
                          src="@/assets/icons/file/info.svg" />
                      </div>
                      <div>
                        <p>
                          {{
                            $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_TWO.BATTERY') +
                            wattHour +
                            $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_TWO.WATT_HOUR')
                          }}
                        </p>
                        <p>{{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_STEP_TWO.EXPRESS') }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-col>

                <v-col md="4" class="align-content-space-between">
                  <v-col class="pa-0">
                    <p>{{ $t('FILE_STEP_TRANSPORT_MODALITY.SELECT_MATERIAL.WEIGHT') }}</p>
                    <v-text-field
                      disabled
                      v-model.trim="packetWeight"
                      :value="packetWeight.toFixed(3) + ' ' + $t('FILE_STEP_TRANSPORT_MODALITY.SELECT_MATERIAL.KILOGRAM')"
                    />
                  </v-col>
                  <v-col class="pa-0">
                    <p>{{ $t('FILE_STEP_TRANSPORT_MODALITY.SELECT_MATERIAL.BIGGEST_WIDTH') }}</p>
                    <v-text-field
                      disabled
                      v-model.trim="biggestWidthProduct"
                      :value="biggestWidthProduct.toFixed(1)
                       + ' ' + $t('FILE_STEP_TRANSPORT_MODALITY.SELECT_MATERIAL.CENTIMETER')"
                    />
                  </v-col>
                  <v-col class="pa-0">
                    <p>{{ $t('FILE_STEP_TRANSPORT_MODALITY.SELECT_MATERIAL.BIGGEST_LENGTH') }}</p>
                    <v-text-field
                      disabled
                      v-model.trim="biggestLengthProduct"
                      :value="biggestLengthProduct.toFixed(1)
                       + ' ' + $t('FILE_STEP_TRANSPORT_MODALITY.SELECT_MATERIAL.CENTIMETER')"
                    />
                  </v-col>
                </v-col>
              </v-row>
            </div>

            <!--TRANSPORT TYPE CHOICE-->
            <v-radio-group v-model="selectedTransportType"
                           :rules="requiredRules"
                           hide-details>
              <v-row class="align-content-center mt-10">
                <!--IMMEDIATE_TRANSPORTER-->
                <v-col cols="12" lg="6" class="d-flex flex-column text-center">
                  <p v-if="!isWhiteListFlow" class="content-express pb-2">
                    {{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_TRANSPORTER.TITLE') }}
                  </p>
                  <p v-if="isWhiteListFlow" class="content-express pb-2">
                    {{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_TRANSPORTER.TITLE_WHITE_LIST') }}
                  </p>

                  <v-card class="select-transporter-card rounded-xl flex-fill"
                          :class="[{ 'not-disabled-card': !checkClientServiceValidity() },
                           checkIfTargeted()]"
                          :disabled="checkClientServiceValidity() || isWhiteListFlow"
                  >
                    <v-row :justify="expressistTransporterList.length > 2 ? 'start' : 'space-around'">
                      <v-col cols="12" md="6"
                             v-for="(expressistTransporter, index) of expressistTransporterList" :key="index">
                        <v-card class="select-transporter-card d-flex flex-column justify-center
                         align-center text-center rounded-xl flex-fill"
                                :class="[{ 'not-disabled-card': !checkClientServiceValidity()
                                 && !checkPacketValidity(expressistTransporter) }]"
                                :disabled="checkPacketValidity(expressistTransporter)">
                          <v-radio :disabled="checkPacketValidity(expressistTransporter)"
                                   :value="expressistTransporter.technical_id"
                                   color="#559A1B"
                          />
                          <div class="transporter-logo">
                            <img v-if="expressistTransporter.connexion.transporter.transporter_type === 'CHRONOPOST'"
                                 alt="chronopost" src="@/assets/icons/file/chronopost.svg" />
                            <img v-if="expressistTransporter.connexion.transporter.transporter_type === 'UPS'"
                                 alt="ups" src="@/assets/icons/file/ups.png" />
                          </div>
                          <p class="content-express">
                            {{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_TRANSPORTER.TYPE') }}
                          </p>
                          <p class="content-express-market">
                            {{ expressistTransporter.connexion.connexion_name }}
                          </p>
                        </v-card>
                      </v-col>
                      <v-col cols="12" v-if="!expressistTransporterList.length"
                             class="d-flex flex-column justify-center align-center text-center">
                        <p class="content-express">
                          {{ $t('FILE_STEP_TRANSPORT_MODALITY.CARD_TRANSPORTER.NO_TRANSPORTER') }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <!--CUSTOMER_SERVICE_TRANSPORTER-->
                <v-col cols="12" lg="3" class="d-flex flex-column text-center">
                  <v-card
                    class="select-card mt-26 rounded-xl flex-fill"
                    :class="[{ 'not-disabled-card': !checkClientServiceValidity() },
                          { 'selected-card': selectedTransportType === 'CUSTOMER_SERVICE_TRANSPORTER' }]"
                    :disabled="checkClientServiceValidity()"
                  >
                    <v-row>
                      <v-col>
                        <div class="d-flex flex-column text-center justify-center align-center">
                          <v-radio color="#559A1B" @click.stop.prevent="openManufacturerTransporterModal()"
                                   value='CUSTOMER_SERVICE_TRANSPORTER' />
                          <p v-if="!isWhiteListFlow" class="content-express">
                            {{
                              $t('FILE_STEP_TRANSPORT_MODALITY.CARD_CUSTOMER_SERVICE.TYPE')
                            }}
                          </p>
                          <p v-if="isWhiteListFlow" class="content-express">
                            {{
                              $t('FILE_STEP_TRANSPORT_MODALITY.CARD_CUSTOMER_SERVICE.TYPE_BOOMERANG')
                            }}
                          </p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <!--WITHOUT_TRANSPORTER-->
                <v-col cols="12" lg="3" class="d-flex">
                  <v-card class="select-card mt-26 rounded-xl flex-fill"
                          :class="[{ 'not-disabled-card': !checkClientServiceValidity() },
                                  { 'selected-card': selectedTransportType === 'WITHOUT_TRANSPORTER' }]"
                          :disabled="checkClientServiceValidity()">
                    <v-row>
                      <v-col>
                        <div class="d-flex flex-column text-center justify-center align-center">
                          <v-radio color="#559A1B"
                                   value="WITHOUT_TRANSPORTER" />
                          <p class="content-express">{{
                              $t('FILE_STEP_TRANSPORT_MODALITY.CARD_WITHOUT_TRANSPORTER.TYPE')
                            }}</p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-radio-group>
          </div>
        </v-card>
      </v-col>

      <!--COMPLETE VALIDATION OF FORM-->
      <v-col cols="12" class="d-flex justify-start">
        <v-btn
          :disabled="(!formStepTransporterValid || !selectedTransportType || loading) && !transportModalityByPass"
          :loading="loading"
          class="pl-15 pr-15"
          :class="(!formStepTransporterValid || !selectedTransportType || loading)
            && !transportModalityByPass ? 'boom-button-transparent' : 'boom-button'"
          type="submit"
          variant="outlined"
        >
          {{
            transportModalityByPass || !selectedTransportType || !selectedTransportModality
              ? $t('COMMON.BUTTON.CONTINUE')
              : $t('FILE_STEP_TRANSPORT_MODALITY.BUTTON.VALIDATION')
          }}
          <img
            alt="arrow_small-icon"
            :class="(!formStepTransporterValid || loading)
              && !transportModalityByPass ? 'arrow-black-svg' : 'arrow-white-svg'"
            src="@/assets/icons/file/arrow_small_right.svg"
          />
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
  <ManufacturerTransporterModal ref="manufacturerTransporterModal" />
  <AddressModal ref="addressModal" />
  <BatteryModal ref="batteryModal" />
</template>

<script>
import { displayToast, handleResponseError, shouldShowTooltip } from '@/components/utils/globalFunction'
import AddressModal from '@/components/modal/repair-file/AddressModal.vue'
import BatteryModal from '@/components/modal/repair-file/BatteryModal.vue'
import ManufacturerTransporterModal from '@/components/modal/repair-file/ManufacturerTransporterModal.vue'
import RepairCenterLinkService from '@/services/RepairCenterLinkService'
import ResponseConstant from '@/constants/responseConstant'
import ProductService from '@/services/ProductService'
import RepairFileService from '@/services/RepairFileService'
import { auth as $store } from '@/store/AuthModule'
import TransportModalityConstant from '@/constants/transportModalityConstant'
import TransportTypeConstant from '@/constants/transportTypeConstant'
import TransporterService from '@/services/TransporterService'
import DeliveryAddressTypeConstant from '@/constants/deliveryAddressTypeConstant'
import StoreService from '@/services/StoreService'
import ManufacturerService from '@/services/referentiel/ManufacturerService'
import { RepairFile } from '@/models/RepairFile'
import ExpressistTransporterService from '@/services/transporters/ExpressistTransporterService'
import ErpStoreService from '@/services/repairModule/erpStore/ErpStoreService'
import Validator from '@/components/utils/validator'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'
import ProductTypeConstant from '@/constants/productTypeConstant'

export default {
  name: 'StepTransporterFolderPage',
  components: {
    AddressModal,
    BatteryModal,
    ManufacturerTransporterModal
  },
  props: {
    currentStep: Number,
    currentRepairFile: {
      type: RepairFile,
      default: null
    }
  },
  data() {
    return {
      formStepTransporterValid: false,
      transportModalityByPass: false,
      stepper: 1,
      loading: false,
      repairCenter: null,
      showStepTwo: false,

      selectedTransportModality: null,
      selectedTransportType: null,
      store: null,

      departureAddress: {
        name: null,
        number: null,
        street: null,
        complementOne: null,
        complementTwo: null,
        zipCode: null,
        city: null,
        contactName: null,
        contactEmail: null,
        contactPhone: null
      },
      sendTo: {
        name: null,
        number: null,
        street: null,
        complementOne: null,
        complementTwo: null,
        zipCode: null,
        city: null,
        contactName: null,
        contactEmail: null,
        contactPhone: null
      },
      returnAddress: {
        name: null,
        number: null,
        street: null,
        complementOne: null,
        complementTwo: null,
        zipCode: null,
        city: null,
        contactName: null,
        contactEmail: null,
        contactPhone: null
      },

      transportModalityList: [],
      transporter: null,

      // TRANSPORTER VARIABLE
      productList: null,
      packetWeight: 0,
      biggestWidthProduct: 0,
      biggestLengthProduct: 0,
      voltage: null,
      amperage: null,
      wattHour: null,
      expressCheckbox: null,
      transporterName: null,
      transporterExpressistLinkId: null,

      expressistTransporterList: [],

      // Milwaukee flow, WhiteList flow, transport with or without guaratee support by boomerang
      isWhiteListFlow: false,

      palletOption: false,

      requiredRules: Validator.requiredRules
    }
  },
  computed: {
    ProductTypeConstant() {
      return ProductTypeConstant
    },
    currentCollaborator() {
      return $store.state.currentCollaborator
    },
    currentCollaboratorFullName() {
      return $store.state.currentCollaborator.firstname + ' ' + $store.state.currentCollaborator.lastname
    },
  },
  watch: {
    async selectedTransportModality() {
      this.repairCenter = null
      if (this.selectedTransportModality
        && this.selectedTransportModality.enum === TransportModalityConstant.TRANSPORTER) {
        this.transportModalityByPass = false
        await this.getRepairCenter()
        if (this.repairCenter) {
          await this.getTransporter()
        }
      } else if (this.selectedTransportModality
        && (this.selectedTransportModality.enum === TransportModalityConstant.WORKSHOP
          || this.selectedTransportModality.enum === TransportModalityConstant.STORE
          || this.selectedTransportModality.enum === TransportModalityConstant.EXCLUDING_SUPPORT)) {
        this.transportModalityByPass = true
        this.showStepTwo = false
      }
    },
    async selectedTransportType() {
      if (this.selectedTransportType !== null
        && this.selectedTransportType !== TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER
        && this.selectedTransportType !== TransportTypeConstant.WITHOUT_TRANSPORTER) {
        this.transporterExpressistLinkId = this.selectedTransportType

        const transporterObject = this.expressistTransporterList
          .find(item => item.technical_id === this.transporterExpressistLinkId)
        if (transporterObject) {
          this.transporterName = transporterObject.connexion.transporter.name
        }
      } else {
        this.transporterExpressistLinkId = null
        this.transporterName = null
      }
    }
  },
  async created() {
    // Check if currentRepairFile product is product support by boomerang white list process
    await this.checkIsWhiteListFlow()

    await this.getSubProduct()
    await this.patchData()
    await this.getExpressistTransporterList()
  },
  methods: {
    shouldShowTooltip,
    async submit() {
      let data = {}
      if (this.transportModalityByPass) {
        data = {
          status_detail: RepairFileStatusDetailConstant.TRANSPORTER_REPAIR_FILE_TRANSFER,
          is_complete_update: 'True',
          requestor_collaborator_id: this.currentCollaborator.technical_id,

          transporter_modality: this.selectedTransportModality?.enum
        }
      } else {
        const product_list_formatted = this.productList.filter((product) => {
          return product.quantity >= 1
        }).map((product) => {
          return product.boomerang_id
        })
        if (this.expressCheckbox === null) {
          this.expressCheckbox = false
        }

        let transportType = TransportTypeConstant.WITHOUT_TRANSPORTER
        if (this.selectedTransportType != null
          && this.selectedTransportType === TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER) {
          transportType = TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER
        } else if (this.selectedTransportType != null
          && this.selectedTransportType === TransportTypeConstant.WITHOUT_TRANSPORTER) {
          transportType = TransportTypeConstant.WITHOUT_TRANSPORTER
        } else if (this.selectedTransportType != null
          && this.selectedTransportType !== TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER
          && this.selectedTransportType !== TransportTypeConstant.WITHOUT_TRANSPORTER) {
          transportType = TransportTypeConstant.IMMEDIATE_TRANSPORTER
        } else {
          transportType = TransportTypeConstant.WITHOUT_TRANSPORTER
        }

        data = {
          status_detail: RepairFileStatusDetailConstant.TRANSPORTER_REPAIR_FILE_TRANSFER,
          is_complete_update: 'True',
          requestor_collaborator_id: this.currentCollaborator.technical_id,

          transporter_modality: this.selectedTransportModality?.enum,

          selected_products_boomerang_id: product_list_formatted,

          transporter_type: transportType,
          transporter_name_selected: this.transporterName,
          transporter_expressist_connexion_link_id_selected: this.transporterExpressistLinkId,
          express_check_box: this.expressCheckbox,

          packet_voltage: this.voltage,
          packet_amperage: this.amperage,
          packet_watt_hour: this.wattHour,

          packet_weight: this.packetWeight * 1000,
          packet_width: this.biggestWidthProduct * 10,
          packet_length: this.biggestLengthProduct * 10,

          departure_address_name: this.departureAddress.name,
          departure_address_number: this.departureAddress.number,
          departure_address_street: this.departureAddress.street,
          departure_address_complement_1: this.departureAddress.complementOne,
          departure_address_complement_2: this.departureAddress.complementTwo,
          departure_address_zip_code: this.departureAddress.zipCode,
          departure_address_city: this.departureAddress.city,
          departure_address_contact_name: this.departureAddress.contactName,
          departure_address_contact_email: this.departureAddress.contactEmail,
          departure_address_contact_phone_number: this.departureAddress.contactPhone,

          return_address_name: this.returnAddress.name,
          return_address_number: this.returnAddress.number,
          return_address_street: this.returnAddress.street,
          return_address_complement_1: this.returnAddress.complementOne,
          return_address_complement_2: this.returnAddress.complementTwo,
          return_address_zip_code: this.returnAddress.zipCode,
          return_address_city: this.returnAddress.city,
          return_address_contact_name: this.returnAddress.contactName,
          return_address_contact_email: this.returnAddress.contactEmail,
          return_address_contact_phone_number: this.returnAddress.contactPhone
        }
      }

      const formData = new FormData()
      formData.append('data', JSON.stringify(data))
      await this.updateStepTransporter(formData, false)
    },
    async updateStepTransporter(formData, isPartial = false) {
      this.loading = true
      const repairFileId = this.currentRepairFile.technical_id
      try {
        let erpCall = false
        let erpCallResponse = false

        if (isPartial === true) {
          await RepairFileService.update(repairFileId, formData)
          return true
        } else {
          if (this.currentRepairFile.with_erp_intern) {
            erpCall = true
            erpCallResponse = await this.erpInternalStoreCall()
          }

          if (erpCall === true && erpCallResponse === false) {
            return false
          } else {
            await RepairFileService.update(repairFileId, formData)

            if (this.selectedTransportModality.enum === TransportModalityConstant.STORE
              || this.selectedTransportModality.enum === TransportModalityConstant.WORKSHOP
              || this.selectedTransportModality.enum === TransportModalityConstant.EXCLUDING_SUPPORT
              || this.selectedTransportType === TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER
              || this.selectedTransportType === TransportTypeConstant.WITHOUT_TRANSPORTER
            ) {
              await this.$router.push('/repair-file/finalization/' + this.currentRepairFile.boomerang_id)
            } else {
              await this.$router.push({ path: '/repair-file/shipping/' + this.currentRepairFile.boomerang_id })
            }
          }
        }
      } catch (error) {
        handleResponseError(error)
        return false
      } finally {
        this.loading = false
      }
    },
    async erpInternalStoreCall() {
      this.loading = true
      try {
        const data = {
          repair_file_id: this.currentRepairFile.technical_id,
          requestor_collaborator_id: this.currentCollaborator.technical_id,
          transporter_modality: this.selectedTransportModality?.enum
        }
        await ErpStoreService.generateOT(data)
        return true
      } catch (error) {
        handleResponseError(error, 'error', true)
        return false
      } finally {
        this.loading = false
      }
    },
    async updatePartialData() {
      let product_list_formatted = []
      if (this.productList) {
        product_list_formatted = this.productList.filter((product) => {
          return product.quantity >= 1
        }).map((product) => {
          return product.boomerang_id
        })
      }

      let transportType = TransportTypeConstant.WITHOUT_TRANSPORTER
      if (this.selectedTransportType != null
        && this.selectedTransportType === TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER) {
        transportType = TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER
      } else if (this.selectedTransportType != null
        && this.selectedTransportType === TransportTypeConstant.WITHOUT_TRANSPORTER) {
        transportType = TransportTypeConstant.WITHOUT_TRANSPORTER
      } else if (this.selectedTransportType != null
        && this.selectedTransportType !== TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER
        && this.selectedTransportType !== TransportTypeConstant.WITHOUT_TRANSPORTER) {
        transportType = TransportTypeConstant.IMMEDIATE_TRANSPORTER
      } else {
        transportType = TransportTypeConstant.WITHOUT_TRANSPORTER
      }

      let data = {
        status_detail: RepairFileStatusDetailConstant.TRANSPORTER_REPAIR_FILE_TRANSFER,
        requestor_collaborator_id: this.currentCollaborator.technical_id,

        selected_products_boomerang_id: product_list_formatted,

        transporter_modality: this.selectedTransportModality?.enum,

        transporter_type: transportType,
        transporter_name_selected: this.transporterName,
        transporter_expressist_connexion_link_id_selected: this.transporterExpressistLinkId,

        express_check_box: this.expressCheckbox,

        packet_voltage: this.voltage | null,
        packet_amperage: this.amperage | null,
        packet_watt_hour: this.wattHour | null,

        packet_weight: this.packetWeight * 1000,
        packet_width: this.biggestWidthProduct * 10,
        packet_length: this.biggestLengthProduct * 10,

        departure_address_name: this.departureAddress.name,
        departure_address_number: this.departureAddress.number,
        departure_address_street: this.departureAddress.street,
        departure_address_complement_1: this.departureAddress.complementOne,
        departure_address_complement_2: this.departureAddress.complementTwo,
        departure_address_zip_code: this.departureAddress.zipCode,
        departure_address_city: this.departureAddress.city,
        departure_address_contact_name: this.departureAddress.contactName,
        departure_address_contact_email: this.departureAddress.contactEmail,
        departure_address_contact_phone_number: this.departureAddress.contactPhone,

        return_address_name: this.returnAddress.name,
        return_address_number: this.returnAddress.number,
        return_address_street: this.returnAddress.street,
        return_address_complement_1: this.returnAddress.complementOne,
        return_address_complement_2: this.returnAddress.complementTwo,
        return_address_zip_code: this.returnAddress.zipCode,
        return_address_city: this.returnAddress.city,
        return_address_contact_name: this.returnAddress.contactName,
        return_address_contact_email: this.returnAddress.contactEmail,
        return_address_contact_phone_number: this.returnAddress.contactPhone
      }
      const formData = new FormData()
      formData.append('data', JSON.stringify(data))

      return await this.updateStepTransporter(formData, true)
    },
    async makeAllCalculate() {
      this.calculateWeight()
      this.biggestWidth()
      this.biggestLength()
      const index = await this.productList.findIndex(product => product.product_type === ProductTypeConstant.BATTERY)
      if (this.productList[index]?.quantity === 0) {
        this.wattHour = null
        this.expressCheckbox = null
      }
    },
    calculateWeight() {
      let weight = 0
      for (const product of this.productList) {
        weight += product.quantity * product.weight
      }
      this.packetWeight = weight
    },
    biggestWidth() {
      let biggestWidth = null
      for (const product of this.productList) {
        if (product.quantity > 0) {
          if (biggestWidth === null) {
            biggestWidth = product.width
          } else {
            if (product.width > biggestWidth) {
              biggestWidth = product.width
            }
          }
        }
      }
      if (biggestWidth / 10 !== 0) {
        this.biggestWidthProduct = biggestWidth / 10
      } else {
        this.biggestWidthProduct = 0
      }
    },
    biggestLength() {
      let biggestLength = null
      for (const product of this.productList) {
        if (product.quantity > 0) {
          if (biggestLength === null) {
            biggestLength = product.length
          } else {
            if (product.width > biggestLength) {
              biggestLength = product.length
            }
          }
        }
      }
      if (biggestLength / 10 !== 0) {
        this.biggestLengthProduct = biggestLength / 10
      } else {
        this.biggestLengthProduct = 0
      }
    },
    async getRepairCenter() {
      try {
        const response = await RepairCenterLinkService.getRepairCenterLinkDetailByRepairFile(this.currentRepairFile.technical_id)
        await this.patchRepairCenter(response.repair_center)
        this.repairCenter = response.repair_center
      } catch (error) {
        handleResponseError(error)
      }
    },
    async getSubProduct() {
      this.loading = true
      try {
        const response = await ProductService.getProductList(this.currentRepairFile.product_boomerang_id)
        this.productList = response.item_list.map(item => {
          const isPallet = item.product_type === ProductTypeConstant.PALLET
          return { ...item, quantity: isPallet ? 1 : 0 }
        })

        this.palletOption = this.productList.some(product => product.product_type === ProductTypeConstant.PALLET)
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async getExpressistTransporterList() {
      try {
        const response = await ExpressistTransporterService
          .getExpressistTransporterListByContext(this.currentRepairFile.store_boomerang_id)
        this.expressistTransporterList = response.item_list
      } catch (error) {
        if (error.response && error.response.data && error.response.data.key === 'not_found_error_key') {
          displayToast(this.$t('ERROR.EXPRESSIST_TRANSPORTER_LINK_NOT_FOUND_ERROR_KEY'), 'error')
        } else {
          displayToast(this.$t('ERROR_STATUS_CODE_MESSAGE.' + (error.response ? error.response.status : 'UNKNOWN')), 'error')
        }
      }
    },
    async patchData() {
      this.store = this.$store.getters['auth/getRepairFileStoreSelected']
      const store_repair_manufacturer_found = this.store.store_repair_manufacturer_list
        .some(item => item.boomerang_id === this.currentRepairFile.manufacturer_boomerang_id)

      if (this.currentRepairFile.manufacturer_boomerang_full_support === true) {
        this.transportModalityList.push({
          name: this.$t('FILE_STEP_TRANSPORT_MODALITY.SELECT.MODALITY_TYPE.TRANSPORTER'),
          enum: TransportModalityConstant.TRANSPORTER,
          value: 1
        })

        if (this.store.store_repair_status === true && store_repair_manufacturer_found) {
          this.transportModalityList.push({
            name: this.$t('FILE_STEP_TRANSPORT_MODALITY.SELECT.MODALITY_TYPE.STORE'),
            enum: TransportModalityConstant.STORE,
            value: 2
          })
        }

        const workshop_deposit_manufacturer_found =
          this.store.workshop_deposit_manufacturer_list
            .some(item => item.boomerang_id === this.currentRepairFile.manufacturer_boomerang_id)
        if (this.store.workshop_deposit_status === true && workshop_deposit_manufacturer_found) {
          this.transportModalityList.push({
            name: this.$t('FILE_STEP_TRANSPORT_MODALITY.SELECT.MODALITY_TYPE.WORKSHOP'),
            enum: TransportModalityConstant.WORKSHOP,
            value: 3
          })
        }
      } else if (this.currentRepairFile.manufacturer_boomerang_full_support === false
        && this.isWhiteListFlow === true) {
        this.transportModalityList.push({
          name: this.$t('FILE_STEP_TRANSPORT_MODALITY.SELECT.MODALITY_TYPE.TRANSPORTER'),
          enum: TransportModalityConstant.TRANSPORTER,
          value: 1
        })

        if (this.store.store_repair_status === true && store_repair_manufacturer_found) {
          this.transportModalityList.push({
            name: this.$t('FILE_STEP_TRANSPORT_MODALITY.SELECT.MODALITY_TYPE.STORE'),
            enum: TransportModalityConstant.STORE,
            value: 2
          })
        }
      } else {
        this.transportModalityList.push({
          name: this.$t('FILE_STEP_TRANSPORT_MODALITY.SELECT.MODALITY_TYPE.EXCLUDING_SUPPORT'),
          enum: TransportModalityConstant.EXCLUDING_SUPPORT,
          value: 1
        })
      }
      await this.patchAddress()
      await this.patchPartial()
    },
    async patchPartial() {
      this.selectedTransportModality = this.transportModalityList
        .find(transporter_modality => transporter_modality.enum === this.currentRepairFile.initial_transporter_modality)

      if (this.selectedTransportModality === undefined) {
        this.stepper = 1
        this.showStepTwo = false
      } else if (this.currentRepairFile.packet_weight > 0) {
        this.stepper++
        this.showStepTwo = true
      }

      this.voltage = this.currentRepairFile.packet_battery_voltage | 0
      this.amperage = this.currentRepairFile.packet_battery_amperage | 0
      this.wattHour = this.currentRepairFile.packet_battery_watt_hour | 0
      this.biggestWidthProduct = this.currentRepairFile.product_width / 10 | 0
      this.biggestLengthProduct = this.currentRepairFile.product_length / 10 | 0

      this.packetWeight = this.currentRepairFile.product_weight / 1000

      if (this.packetWeight > 0) {
        this.productList.forEach(product => {
          this.currentRepairFile.product_guarantee_list.forEach(product_guarantee => {
            if (product.boomerang_id === product_guarantee.product_boomerang_id) {
              if (product.product_type === ProductTypeConstant.PALLET) {
                product.quantity = 1
              } else {
                product.quantity += 1
              }
            }
          })
        })
      }

      await this.makeAllCalculate()

      this.transporterName = this.currentRepairFile.initial_transporter_name
      this.transporterExpressistLinkId = this.currentRepairFile.initial_expressist_transporter_connexion_link_id !== 0
        ? this.currentRepairFile.initial_expressist_transporter_id : null
      this.expressCheckbox = this.currentRepairFile.express_check_box
      const departureAddress = this.currentRepairFile.delivery_address_list
        .find(address => address.type === DeliveryAddressTypeConstant.DEPARTURE)
      const returnAddress = this.currentRepairFile.delivery_address_list
        .find(address => address.type === DeliveryAddressTypeConstant.RETURN)

      if (departureAddress) {
        this.departureAddress.name = departureAddress.address_name
        this.departureAddress.number = departureAddress.address_number
        this.departureAddress.street = departureAddress.address_street
        this.departureAddress.complementOne = departureAddress.address_complement_1
        this.departureAddress.complementTwo = departureAddress.address_complement_2
        this.departureAddress.zipCode = departureAddress.address_zip_code
        this.departureAddress.city = departureAddress.address_city
        this.departureAddress.contactName = departureAddress.contact_name
        this.departureAddress.contactEmail = departureAddress.contact_email
        this.departureAddress.contactPhone = departureAddress.contact_phone
      }
      if (returnAddress) {
        this.returnAddress.name = returnAddress.address_name
        this.returnAddress.number = returnAddress.address_number
        this.returnAddress.street = returnAddress.address_street
        this.returnAddress.complementOne = returnAddress.address_complement_1
        this.returnAddress.complementTwo = returnAddress.address_complement_2
        this.returnAddress.zipCode = returnAddress.address_zip_code
        this.returnAddress.city = returnAddress.address_city
        this.returnAddress.contactName = returnAddress.contact_name
        this.returnAddress.contactEmail = returnAddress.contact_email
        this.returnAddress.contactPhone = returnAddress.contact_phone
      }
    },
    async patchAddress() {
      this.departureAddress.name = this.store.label_name
      this.departureAddress.number = this.store.address_number
      this.departureAddress.street = this.store.address_street
      this.departureAddress.complementOne = this.store.address_complement_1
      this.departureAddress.complementTwo = this.store.address_complement_2
      this.departureAddress.zipCode = this.store.address_zip_code
      this.departureAddress.city = this.store.address_city
      this.departureAddress.contactName = this.currentCollaboratorFullName
      this.departureAddress.contactEmail = this.store.contact_email
      this.departureAddress.contactPhone = this.store.phone_number
      this.returnAddress = Object.assign({}, this.departureAddress)
    },
    async patchRepairCenter(repairCenter) {
      this.sendTo.name = repairCenter.name
      this.sendTo.number = repairCenter.address_number
      this.sendTo.street = repairCenter.address_street
      this.sendTo.complementOne = repairCenter.address_complement
      this.sendTo.zipCode = repairCenter.address_zip_code
      this.sendTo.city = repairCenter.address_city
      this.sendTo.contactName = repairCenter.name
      this.sendTo.contactEmail = repairCenter.collect_email
      this.sendTo.contactPhone = repairCenter.phone_number
    },
    async openAddressModal(cardName) {
      let title = null
      let addressInfo = null
      if (cardName === 'send_from') {
        title = this.$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.TITLE.SEND_FROM')
        addressInfo = this.departureAddress
      } else if (cardName === 'receive_by') {
        addressInfo = this.returnAddress
        title = this.$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.TITLE.RECEIVE_TO')
      } else {
        title = this.$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.TITLE.SEND_TO')
      }
      const response = await this.$refs.addressModal.show({
        addressInfo: addressInfo,
        title: title
      })
      if (response.confirmed) {
        if (cardName === 'send_from') {
          this.departureAddress = Object.assign({}, response.addressInfo)
        } else {
          this.returnAddress = Object.assign({}, response.addressInfo)
        }
      }
    },
    async openBatteryModal(selectedProduct) {
      const response = await this.$refs.batteryModal.show()

      if (response.confirmed) {
        this.wattHour = response.wattHour
        this.voltage = response.voltage
        this.amperage = response.amperage
        this.expressCheckbox = response.expressCheckbox
      } else {
        let index = await this.productList.findIndex(product => product.boomerang_id === selectedProduct.boomerang_id)
        this.productList[index].quantity = 0
        await this.makeAllCalculate()
      }
    },
    async openManufacturerTransporterModal() {
      this.selectedTransportType = TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER
      this.transporterExpressistLinkId = null
      this.transporterName = null

      await this.updatePartialData()

      const email_to = this.isWhiteListFlow ? import.meta.env.VITE_MAIL_BOOMERANG_ADMIN : this.repairCenter.collect_email
      const phone_to = this.isWhiteListFlow ? '' : this.repairCenter.phone_number

      const response = await this.$refs.manufacturerTransporterModal.show({
        isWhiteListFlow: this.isWhiteListFlow,
        email: email_to,
        phoneNumber: phone_to,
        erpRepairerNumber: this.transporter?.erp_repairer_number || 'XXXXX',
        boomerangId: this.currentRepairFile.boomerang_id,
        internalCommandNumber: this.currentRepairFile.internal_command_number
      })

      if (response.confirmed) {
        await this.submit()
      } else {
        this.selectedTransportType = null
        this.transporterExpressistLinkId = null
        this.transporterName = null
        this.formStepTransporterValid = false
      }
    },
    checkPacketValidity(expressistTransporter) {
      // Check if this.selectedTransportType == IMMEDIATE_TRANSPORT with id of transporter
      let reset = false
      if (this.selectedTransportType !== null
        && this.selectedTransportType !== TransportTypeConstant.CUSTOMER_SERVICE_TRANSPORTER
        && this.selectedTransportType !== TransportTypeConstant.WITHOUT_TRANSPORTER) {
        // If yes, we need reset this.selectedTransportType and this.transporterExpressistLinkId
        // if we disable this transporter option
        reset = true
      }

      let disable = false

      const isChronopost = expressistTransporter.connexion.transporter.transporter_type === 'CHRONOPOST'
      const hasPallet = this.productList.some(
        product => product.product_type === ProductTypeConstant.PALLET && product.quantity === 1
      )
      const isHeavyPacket = this.packetWeight > 20

      if (this.biggestLengthProduct * 10 > expressistTransporter.connexion.transporter.height_max
        || this.biggestWidthProduct * 10 > expressistTransporter.connexion.transporter.width_max
        || this.packetWeight > expressistTransporter.connexion.transporter.weight_max) {
        // if Length, width or Weight are too big, we disable this transport option
        disable = true
      } else if (!this.productList.some(product => product.quantity === 1)) {
        // if no product selected, we disable this transport option
        disable = true
      } else if (isChronopost && (hasPallet || isHeavyPacket)) {
        // if product pallet selected, we disable this transport option
        disable = true
      } else {
        // if watt per hour is too big for transporter settings, we  disable this transport option
        disable = this.wattHour > expressistTransporter.connexion.transporter.power_max
          && this.expressCheckbox !== true
      }

      if (disable && reset) {
        // If we disable this transport option, and we need reset selection
        // We reset selection
        this.selectedTransportType = null
        this.transporterExpressistLinkId = null
        return true
      } else {
        // else, just return disable status without reset.
        return disable && !reset
      }
    },
    checkClientServiceValidity() {
      if (!this.productList.some(product => product.quantity === 1)) {
        this.selectedTransportType = null
        this.transporterExpressistLinkId = null
        return true
      }
      return false
    },
    setError(key) {
      switch (key) {
        default:
          this.error = ''
      }
    },
    async nextStep() {
      const updateIsOk = await this.updatePartialData()

      if (updateIsOk) {
        this.stepper++
        this.showStepTwo = true
      }
    },
    async getTransporter() {
      const data = {
        network_boomerang_id: this.currentRepairFile.network_boomerang_id,
        repair_center_boomerang_id: this.repairCenter?.boomerang_id,
        store_boomerang_id: this.currentRepairFile.store_boomerang_id
      }
      try {
        this.transporter = await TransporterService.getTransporter(data)
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
      }
    },
    checkIfTargeted() {
      const found = this.expressistTransporterList
        .some(item => item.technical_id === this.transporterExpressistLinkId)
      if (found) {
        return 'selected-card'
      } else {
        return ''
      }
    },
    async checkIsWhiteListFlow() {
      try {
        const storeWhiteListConfiguration = await StoreService
          .getStoreWhiteListConfiguration(this.currentRepairFile.store_boomerang_id)

        if (storeWhiteListConfiguration.milwaukee_support_status) {
          const responseManufacturerListInMilwaukeeWhitelist =
            await ManufacturerService.getManufacturerListInMilwaukeeWhitelist()

          if (responseManufacturerListInMilwaukeeWhitelist.item_list
            .some(manufacturer_in =>
              manufacturer_in.boomerang_id === this.currentRepairFile.manufacturer_boomerang_id)) {
            this.isWhiteListFlow = true
          }
        }

        if (storeWhiteListConfiguration.transport_with_guarantee_support_status) {
          const responseManufacturerListInGuaranteeTransportWhitelist =
            await StoreService.getGuaranteeTransportManufacturerList(this.currentRepairFile.store_boomerang_id)
          if (responseManufacturerListInGuaranteeTransportWhitelist.item_list
            .some(manufacturer_in =>
              manufacturer_in.boomerang_id === this.currentRepairFile.manufacturer_boomerang_id)) {
            this.isWhiteListFlow = true
          }
        }

        if (storeWhiteListConfiguration.transport_without_guarantee_support_status) {
          const responseManufacturerListInWithoutGuaranteeTransportWhitelist =
            await StoreService.getWithoutGuaranteeTransportManufacturerList(this.currentRepairFile.store_boomerang_id)
          if (responseManufacturerListInWithoutGuaranteeTransportWhitelist.item_list
            .some(manufacturer_in =>
              manufacturer_in.boomerang_id === this.currentRepairFile.manufacturer_boomerang_id)) {
            this.isWhiteListFlow = true
          }
        }
      } catch (error) {
        handleResponseError(error)
      }
    }
  }
}
</script>

<style scoped>
.parent-card {
  padding: 40px !important;
}

.information-content-title {
  margin-top: 40px;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.address-card {
  padding: 20px !important;
  position: relative;
  box-shadow: unset;
  border: 1px solid #DADADA;
  border-radius: 10px;
}

.title-card {
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.title-product {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px
}

.content-product {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.content-card {
  font-style: normal;
  font-weight: 400;
}

.content-value {
  color: #727272;
  font-style: normal;
  font-weight: 400;
}

.btn-minus,
.btn-plus {
  font-size: 18px;
}

.svg-minus-disabled {
  filter: invert(82%) sepia(0%) saturate(1678%) hue-rotate(90deg) brightness(86%) contrast(84%);
}

.arrow-white-svg {
  height: 100%;
  width: 50%;
  filter: invert(100%) sepia(0%) saturate(1%) hue-rotate(209deg) brightness(109%) contrast(101%)
}

.transporter-card {
  background-color: #DADADA
}

.svg-check-rounded {
  width: 18px;
  height: 18px;
}

.watt-hour-card {
  width: 100%;
  height: 90%;
  padding: 20px !important;
  position: relative;
  box-shadow: unset;
  background-color: #FAFAFA;
  border: 1px solid #DADADA;
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;
  text-align: start;
  display: flex;
}

.select-transporter-card {
  padding: 20px !important;
  position: relative;
  box-shadow: unset;
  border: 1px solid #EFEFEF;
  background-color: #EFEFEF;
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;
  text-align: start;
  display: flex;
}

.selected-card {
  border: 1px solid #559A1B !important;
}

.select-card {
  padding: 20px !important;
  position: relative;
  box-shadow: unset;
  background-color: #EFEFEF;
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;
  text-align: start;
  display: flex;
}

.content-express {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}

.content-express-market {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.transporter-logo {
  width: 9.3rem;
  height: 6.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.transporter-logo img {
  max-height: 50%;
}

.title-button {
  cursor: pointer;
}

.title-button:hover {
  color: #559A1B;
}

.mt-26 {
  margin-top: 26px;
}

.not-disabled-card {
  background-color: white;
  border: 1px solid #EFEFEF;
}
</style>
